import React, { useState } from 'react';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';
import cn from 'classnames';
import _ from 'lodash';
import './ReceiptsPanel.scss';

const humanizeReason = reason => reason.replace(/_/g, ' ');

// The last 7 days of receipts for one template, as bars: sent, each hold reason, failed, shadow.
const ReceiptsPanel = ({ receipts }) => {
  const [open, setOpen] = useState(true);
  const held = receipts?.held || {};
  const bars = receipts
    ? [
        { key: 'sent', label: 'Sent', value: receipts.sent, tone: 'sent' },
        ..._.sortBy(Object.entries(held), ([, n]) => -n).map(([reason, n]) => ({ key: `held-${reason}`, label: `Held · ${humanizeReason(reason)}`, value: n, tone: 'held' })),
        { key: 'failed', label: 'Failed', value: receipts.failed, tone: 'failed' },
        { key: 'shadow', label: 'Shadow', value: receipts.shadow, tone: 'shadow' }
      ].filter(bar => bar.value > 0 || bar.key === 'sent')
    : [];
  const max = Math.max(1, ...bars.map(bar => bar.value));

  return (
    <div className='receipts-panel'>
      <div className='receipts-panel-header' onClick={() => setOpen(!open)}>
        <span className='sidebar-title'>Last 7 Days</span>
        <span className={cn('expand-icon', { open })}>&rsaquo;</span>
      </div>
      {open && (
        <div className='receipts-list'>
          {!receipts || !receipts.total ? (
            <div className='receipts-empty'>No receipts in the last 7 days.</div>
          ) : (
            bars.map(bar => (
              <div key={bar.key} className='receipt-bar'>
                <span className='bar-label'>{bar.label}</span>
                <div className='bar-track'>
                  <div className={cn('bar-fill', bar.tone)} style={{ width: `${Math.round((bar.value / max) * 100)}%` }} />
                </div>
                <span className='bar-value'>{commaNumber(bar.value)}</span>
              </div>
            ))
          )}
          <div className='receipts-note'>From the receipt ledger, every decision this template made. Shadow rows are rehearsals, not sends.</div>
        </div>
      )}
    </div>
  );
};

ReceiptsPanel.propTypes = {
  receipts: PropTypes.object
};

export default ReceiptsPanel;
